import config from '../../../config';
import Request from '../../Request';

export default function uploadFile(id, file, attribute, onSuccess, onFailure) {
  let formData = new FormData()
  formData.append(`file`, file)
  formData.append(`attribute`, attribute)
  Request.patch(`${config.apiUrl}/organizations/${id}/upload_file`, formData, onSuccess, onFailure);
}